import React from 'react'

import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import type { TableProps } from '@fourthwall/components'
import { List, Table, useMediaQueryContext } from '@fourthwall/components'
import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider'

import type { State, ThankYou } from '../../ThankYous.types'
import { getTableHeaders } from '../../utils/getTableHeaders'
import { ThankYouListItem } from '../ThankYouListItem/ThankYouListItem'

type ThankYousDataProps = {
  data: ThankYou[]
  isLoading: boolean
  emptyComponent: TableProps['emptyComponent']
  activeTab: State
  onRowClick: ((item: ThankYou) => void) | undefined
}

export const ThankYousData = ({
  data,
  isLoading,
  activeTab,
  emptyComponent,
  onRowClick,
}: ThankYousDataProps) => {
  const { hasPermission } = useDashboardPermissions()
  const media = useMediaQueryContext()
  const { timezoneAbbreviation } = useShopTime()

  if (!media.tablet) {
    return (
      <List
        data={data}
        isLoading={isLoading}
        emptyComponent={emptyComponent}
        renderItem={(thankYou: ThankYou) => <ThankYouListItem thankYou={thankYou} />}
        onClick={onRowClick}
      />
    )
  }

  return (
    <Table
      data={data}
      headers={getTableHeaders(activeTab, timezoneAbbreviation, {
        hideProfitColumn: !hasPermission('contributions.profit'),
      })}
      isLoading={isLoading}
      emptyComponent={emptyComponent}
      onRowClick={onRowClick ? (item) => onRowClick(item as ThankYou) : undefined}
    />
  )
}
